import { useMemo } from 'react';
import { mapBackendConfig, getStylesFromConfig } from '../services/configService';

/**
 * Hook personalizado para manejar la configuración de LivenessV7
 * @param {Object} configValue - Configuración recibida del servicio
 * @param {boolean} configLoading - Estado de carga de la configuración
 * @returns {Object} Configuración procesada y estilos
 */
export const useLivenessConfig = (configValue, configLoading) => {
  const config = useMemo(() => {
    return mapBackendConfig(configValue);
  }, [configValue]);

  const styles = useMemo(() => {
    return getStylesFromConfig(config);
  }, [config]);

  const timing = useMemo(() => ({
    okFramesTarget: config.timing.okFramesTarget,
    autoCloseDelayMs: config.timing.autoCloseDelayMs,
    passProbabilityThreshold: config.timing.passProbabilityThreshold,
    timeout: config.timing.timeout,
  }), [config]);

  const sdkConfig = useMemo(() => config.sdk, [config]);

  const cameraConfig = useMemo(() => config.camera, [config]);

  const validations = useMemo(() => config.validations, [config]);

  const getMessages = useMemo(() => {
    return (language = 'es') => {
      return language === 'es' ? config.messages : config.messagesEnglish;
    };
  }, [config]);

  return {
    config,
    styles,
    timing,
    sdkConfig,
    cameraConfig,
    validations,
    getMessages,
    isLoading: configLoading,
    closeIcon: config.closeIcon,
    typeCamera: config.typeCamera,
    informativeText: config.informativeText,
    timeout: config.timeout,
    backgroundInMessage: config.backgroundInMessage,
    showBack: config.showBack,
    showFlash: config.showFlash,
    SPF: config.SPF,
  };
};

export default useLivenessConfig;
